import { TFunction } from 'i18next';

export function getStepperLabels(
	t: TFunction<'translation', undefined, 'translation'>,
	isMerchant: boolean,
	isSellOrder: boolean,
) {
	return (isMerchant && isSellOrder) || (!isMerchant && !isSellOrder)
		? [
				{ title: '', description: t<string>('transferPayment') },
				{ title: '', description: t<string>('waitingForRelease') },
				{ title: '', description: t<string>('completed') },
		  ]
		: [
				{ title: '', description: t<string>('waitingForPayment') },
				{ title: '', description: t<string>('releasePayment') },
				{ title: '', description: t<string>('completed') },
		  ];
}
